import {EvaCardModule} from '../eva-card/eva-card.module';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {EvaCardsWrapperComponent, EvaCardsSliderWrapperComponent, EvaCardsGridWrapperComponent, SlideItemButton} from './eva-cards-wrapper.component';
import { SliderModule } from '@shopping-angular-components/slider';
import {GridModule} from '../grid/grid.module';
import {TagTextModule} from '../tag-text/tag-text.module';
import {TextModule} from '../text/text.module';
import { EvaButtonModule } from '../eva-button/eva-button.module';
import { MediaPictureGalleryModule } from '@shopping-angular-components/media-picture-gallery';
import { SliderProModule } from '../slider-pro/slider-pro.module';

@NgModule({
    declarations: [
        EvaCardsWrapperComponent,
        EvaCardsSliderWrapperComponent,
        EvaCardsGridWrapperComponent,
        SlideItemButton
    ],
    imports: [
        CommonModule,
        EvaButtonModule,
        EvaCardModule,
        SliderModule,
        SliderProModule,
        GridModule,
        TagTextModule,
        TextModule,
        MediaPictureGalleryModule
    ],
    exports: [
        EvaCardsWrapperComponent
    ],
    providers: [],
})
export class EvaCardsWrapperModule {
}
